import React from 'react';
import axios from 'axios';
import 'react-table/react-table.css';
import Pagination from 'react-js-pagination';
import { LinearProgress } from 'react-md';
import '../../../node_modules/react-md/dist/react-md.indigo-blue.min.css';
import 'bootstrap-datepicker/js/bootstrap-datepicker.js';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css';
import Loader from '../../_components/loader';
import 'react-notifications/lib/notifications.css';
import { AdminUrls } from '../../network/config';
// import "./style.css";
import { connect } from 'react-redux';
import { removeData } from '../../store/action';
import noIcon from '../../assets/no-icon.png';
import tickIcon from '../../assets/newYes.png';
import moment from 'moment';
import { apiCall } from '../../Services/API';

const randomCompliant_Url = AdminUrls.ADMIN.CPDRANDCOMPLAIANCEREPORT;
const cpdDownloadExcel = AdminUrls.ADMIN.RANDOMCOMPLIANTEXCEL;

class RandomReport extends React.Component {
  constructor() {
    super();
    this.handlePageChange = this.handlePageChange.bind(this);
    this.clearSearchFilters = this.clearSearchFilters.bind(this);
    this.downloadExcel = this.downloadExcel.bind(this);
    this.getCpdCompliantReport = this.getCpdCompliantReport.bind(this);

    this.pageChange = this.pageChange.bind(this);
    this.viewMemberCpdHandler = this.viewMemberCpdHandler.bind(this);
    this.yearOptionDropdown = this.yearOptionDropdown.bind(this);

    this.state = {
      totalPages: 0,
      totalCount: 0,
      per_page: 10,
      activePage: 0,
      unauthorized: false,
      cpdYear: new Date().getFullYear().toString(),
      loadCpdCompliant: [],
      mainLoading: false,
      emptyDivMsg: 'There is no data to show in the grid.',
      sort: {
        column: 'MemberNumber',
        direction: 'desc',
      },
      yearCpd: '',
    };
    this.controller = new AbortController();
  }

  downloadExcel() {
    let date = new Date();
    let newDate = date.getTime();
    var fileType = 'application/vnd.ms-excel';
    var name;
    this.setState({ mainLoading: true });
    axios(cpdDownloadExcel, {
      responseType: 'blob',
      method: 'GET',
      signal: this.controller.signal,
      withCredentials: true,
      credentials: 'include',
      headers: {
        Authorization:
          `${this.props.user.token_type} ` + this.props.user.access_token,
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        var blob = new Blob([response.data], { type: fileType });

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, name);
        } else {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `RandomCompliantReport${newDate}.xlsx`);
          document.body.appendChild(link);
          link.click();
        }
      })
      .then((data) => {
        this.setState({ mainLoading: false });
      })
      .catch((error) => {
        if (error?.response?.status && error?.response?.status === 401) {
          this.props.signOut();
        }
      });
  }

  handlePageChange(pageNumber) {
    this.setState({
      activePage: pageNumber,
    });
    this.getCpdCompliantReport(pageNumber);
  }

  componentDidMount() {
    this.getCpdCompliantReport(1);
    this.yearOptionDropdown();
  }

  clearSearchFilters() {
    this.setState(
      {
        totalPages: 0,
        totalCount: 0,
        per_page: 10,
        activePage: 0,
        unauthorized: false,
        cpdYear: '',
      },
      () => {
        this.getCpdCompliantReport(1);
      }
    );
  }

  getCpdCompliantReport(active, column, direction) {
    let reverse = this.state.sort.direction;
    let sortBy = this.state.sort.column;
    let year = this.state.cpdYear;
    this.setState({
      mainLoading: true,
    });
    if (column) {
      sortBy = column;
    }

    if (direction) {
      reverse = direction;
    }
    reverse = reverse === 'asc' ? false : true;
    let obj = {
      page: active,
      pageSize: this.state.per_page,
      reverse: reverse,
      sortBy: sortBy,
    };

    if (year) {
      obj.Year = year;
    } else {
      obj.Year = new Date().getFullYear();
    }

    axios
      .get(randomCompliant_Url, {
        params: obj,
        method: 'GET',
        signal: this.controller.signal,
        withCredentials: true,
        credentials: 'include',
        headers: {
          Authorization:
            `${this.props.user.token_type} ` + this.props.user.access_token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        this.setState({
          loadCpdCompliant: response?.data?.Items,
          activePage: response?.data?.Page,
          totalCount: response?.data?.TotalCount,
          totalPages: response?.data?.TotalPages,
          mainLoading: false,
        });
      })

      .catch((error) => {
        if (error?.response?.status && error?.response?.status === 401) {
          this.props.signOut();
        }
      });
  }

  onSort = (column) => (e) => {
    const direction = this.state.sort.column
      ? this.state.sort.direction === 'asc'
        ? 'desc'
        : 'asc'
      : 'desc';
    this.setState({
      sort: {
        column,
        direction,
      },
    });
    this.getCpdCompliantReport(this.state.activePage, column, direction);
  };

  async yearOptionDropdown() {
    apiCall
      .getCpdYear()
      .then((response) => {
        this.setState({
          CPDYearList: response?.data,
        });
      })
      .catch((error) => {
        if (error?.response?.status && error?.response?.status === 401) {
          this.props.signOut();
        } else {
          this.setState({
            CPDYearList: ['2022', '2023', '2024', '2025'],
          });
        }
      });
  }

  setArrow = (column) => {
    let className = 'fa fa-sort';
    if (this.state.sort.column === column) {
      className += this.state.sort.direction === 'asc' ? '-asc' : '-desc';
    }
    return className;
  };

  pageChange(pageQty) {
    this.setState(
      {
        per_page: pageQty,
      },
      () => {
        this.getCpdCompliantReport(this.state.activePage);
      }
    );
  }

  viewMemberCpdHandler(id, userid) {
    let obj = {
      Id: id,
      uid: userid,
    };
    this.props.history.push({
      pathname: '/my_cpd_report',
      state: obj,
    });
  }

  componentWillUnmount() {
    this.controller.abort();
  }

  render() {
    let loadCpdCompliant;
    //
    if (this.state?.loadCpdCompliant !== null) {
      loadCpdCompliant = this.state?.loadCpdCompliant?.map((item, index) => {
        return (
          <tr key={index}>
            <td>{item?.MemberNumber}</td>
            <td>{item?.username}</td>
            <td>{item?.Email}</td>

            <td>
              {item?.IsCPDCompliant === 'False' ? (
                <img src={noIcon} alt="noIcon" />
              ) : (
                <img src={tickIcon} alt="tickIcon" />
              )}
            </td>
            <td>{item?.CPDYear}</td>

            <td>{item?.Duration ? item?.Duration : 'na'}</td>
            <td>
              <span
                style={{ fontWeight: 'normal' }}
                ng-class="{'label label-success': row.Status == 'Active' , 'label label-danger': row.Status == 'Terminated'}"
                className="label label-success"
              >
                <span className="ng-binding">{item?.Status}</span>
              </span>
            </td>
            {/* <td></td> */}
            <td> {moment(item?.CompletionDate).format('ll')}</td>
            <td>
              <button
                className="icon-individual"
                onClick={() =>
                  this.viewMemberCpdHandler(item?.MemberId, item?.UserId)
                }
              >
                <i className="fa fa fa-eye"></i>
              </button>
            </td>
          </tr>
        );
      });
    }

    return (
      <div>
        {this.state.mainLoading && <LinearProgress id="main-loader" />}
        <div>
          <div className="panel panel-default">
            <div className="panel-heading-cpd-3" style={{ padding: '10px' }}>
              <i
                className="fa fa-filter "
                title=""
                data-original-title="Search"
              >
                {' '}
                Search
              </i>
            </div>
            <div className="shadow">
              <div className="layout-gt-sm-row">
                <div style={{ padding: '1rem 1rem' }}>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group admin-forms">
                        <label>Year</label>
                        <select
                          value={this.state.cpdYear}
                          className="form-control"
                          onChange={(e) =>
                            this.setState({
                              cpdYear: e.target.value,
                            })
                          }
                          id="sel1"
                        >
                          {/* <option></option>
                          <option value={'2022'}>2022</option>
                          <option value={'2023'}>2023</option>
                          <option value={'2024'}>2024</option>
                          <option value={'2025'}>2025</option> */}
                          {/* {this.state.CPDYearList} */}
                          {this?.state?.CPDYearList &&
                            this?.state?.CPDYearList.map((item) => {
                              return (
                                <option value={item} key={item}>
                                  {item}
                                </option>
                              );
                            })}
                        </select>
                      </div>
                    </div>
                  </div>

                  <div>
                    <button
                      className="btn btn-primary"
                      style={{ marginRight: '10px' }}
                      onClick={() => this.getCpdCompliantReport(1)}
                    >
                      <span className="glyphicon glyphicon-search"> </span>{' '}
                      Search
                    </button>
                    <button
                      className="btn btn-primary"
                      onClick={this.clearSearchFilters}
                    >
                      <span className="glyphicon glyphicon-remove-sign"> </span>{' '}
                      Clear
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-8">
            <div className="gridTopButtons">
              <button
                type="button"
                onClick={() => window.print()}
                className="btn btn-danger btn-circle btn-lg "
              >
                <i className="fa fa-print"> </i>
              </button>

              <button
                type="button"
                onClick={this.downloadExcel}
                className="btn btn-success btn-circle btn-lg"
                style={{ marginLeft: '10px' }}
              >
                <i className="fa fa-file-pdf-o"> </i>
              </button>

              <button
                type="button"
                style={{ marginLeft: '10px' }}
                onClick={() => this.getCpdCompliantReport(1)}
                className="btn btn-primary btn-circle btn-lg "
              >
                <i className=" fa fa-refresh"> </i>
              </button>
            </div>
          </div>

          <div className="col-md-4">
            <div className="gridTopDropdown">
              Show{' '}
              <select
                className="input-sm"
                aria-invalid="false"
                onChange={(e) => this.pageChange(e.target.value)}
              >
                <option label="10" value="10">
                  10
                </option>
                <option label="20" value="20">
                  20
                </option>
                <option label="30" value="30">
                  30
                </option>
              </select>{' '}
              entries
            </div>
          </div>
        </div>
        <div className="col-table">
          {this.state.mainLoading && <Loader />}
          <table className="table table-striped table-bordered table-hover table-condensed">
            <thead>
              <tr className="header">
                <th onClick={this.onSort('MemberNumber')}>
                  Member Number{' '}
                  <i className={this.setArrow('MemberNumber')}> </i>
                </th>
                <th onClick={this.onSort('username')}>
                  User Name <i className={this.setArrow('username')}> </i>
                </th>
                <th onClick={this.onSort('Email')}>
                  Email <i className={this.setArrow('Email')}> </i>
                </th>
                <th>CPD Compliant </th>
                <th onClick={this.onSort('Year')}>
                  Year <i className={this.setArrow('Year')}> </i>
                </th>
                <th onClick={this.onSort('Duration')}>
                  CPD Hours Recorded{' '}
                  <i className={this.setArrow('Duration')}> </i>
                </th>
                <th onClick={this.onSort('Status')}>
                  Status <i className={this.setArrow('Status')}> </i>
                </th>
                <th onClick={this.onSort('CompletionDate')}>
                  Declared Date{' '}
                  <i className={this.setArrow('CompletionDate')}> </i>
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody>{loadCpdCompliant}</tbody>
          </table>
          {loadCpdCompliant?.length > 0 ? '' : this.state.emptyDivMsg}
        </div>
        <div>
          <Pagination
            prevPageText="Previous"
            nextPageText="Next"
            activePage={this.state.activePage}
            itemsCountPerPage={this.state.per_page}
            totalItemsCount={this.state.totalCount}
            onChange={this.handlePageChange}
          />
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    user: state,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    signOut: () => dispatch(removeData()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(RandomReport);
